import MenuItem from "@mui/material/MenuItem";
import React from "react";
import Select from "@mui/material/Select";
import { FilterTextField } from "@ntg/components/text-fields";
import { useTheme } from "@mui/material/styles";

interface DashboardToolbarProps {
    onValueChange: (value: string) => void;
    SearchTerm: string;
}

export default function ActualBoatToolbar(props: DashboardToolbarProps) {
    const [selectedCompany, setSelectedCompany] = React.useState<string>("All");
    // const theme = useTheme();
    function handleChange(event: { target: { value: React.SetStateAction<string>; }; }): void {
        setSelectedCompany(event.target.value);
    }

    return (

        <div
            style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
                width: "100%",
            }}
        >
            <FilterTextField
                className="cs-control"
                initialValue={props.SearchTerm}

                sx={{

                    minWidth: 0,
                    order: 2,
                    width: "1fr",
                    }}
                variant="outlined"

                onFilterApply={(value: string): void => {
                    props.onValueChange(value);
                }}
            />

            <Select
                className="cs-control"
                size="small"
                sx={{
                    minWidth: 0,
                    order: 2,
                    width: "1fr",
                }}
                value={selectedCompany}
                variant="outlined"
                onChange={handleChange}

            >
                <MenuItem value="All">All Companies</MenuItem>
                <MenuItem value="US">US</MenuItem>
                <MenuItem value="EU">EU</MenuItem>
            </Select>
            <Select
                className="cs-control"
                size="small"
                sx={{
                    minWidth: 0,
                    order: 2,
                    width: "1fr",

                }}
                value={selectedCompany}
                variant="outlined"
                onChange={handleChange}
            >
                <MenuItem value="All">All Companies</MenuItem>
                <MenuItem value="US">US</MenuItem>
                <MenuItem value="EU">EU</MenuItem>
            </Select>

            <Select
                className="cs-control"
                size="small"
                sx={{
                    minWidth: 0,
                    order: 3,
                    width: "1fr",

                }}
                value={selectedCompany}
                variant="outlined"
                onChange={handleChange}
            >
                <MenuItem value="All">All Divisions</MenuItem>
                <MenuItem value="US">US</MenuItem>
                <MenuItem value="EU">EU</MenuItem>
            </Select>
        </div>

    );
}